define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var ProfileModel = require("models/entities/ProfileModel");
    var LEResourceResolver = require("leResourceResolver");
    var DependencyService = require("src/components/dependency-service/controllers/DependencyService");

    var URL_PARAMETERS = "&selector=$all";

    var ProfilesCollection = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        ProfilesCollection = RevisionedCollection.extend({
            model: ProfileModel,
            name: "DefaultProfilesCollection",
            resource: ApiResources.AccountConfig.DefaultProfiles,

            url: function(){ //we need to override backbone to not include '/' and the temp id we give to the model before deleting
                var url = RevisionedCollection.prototype.url.apply(this, arguments);
                url = url + URL_PARAMETERS;
                return url;
            },
            initialize: function (models, options) {
                options = options || {};
                RevisionedCollection.prototype.initialize.call(this, models, options);
            },

            fetch: function (options) {
                options = options ? _.clone(options) : {};
                var origSuccess = options.success;
                var origError = options.error;

                options.success = _.bind(function (collection, resp, opt) {
                    if (origSuccess) {
                        origSuccess(collection, resp, options);
                    }
                }, this);

                RevisionedCollection.prototype.fetch.call(this, options);
            },
            getModelByRole: function (roleTypeId) {
                var found = _.findIndex(this.models, function (model) {
                    return model.getRoleTypeId() == roleTypeId;
                });
                if (found !== -1) {
                    return this.models[found];
                }
            },
            isCollectionAllowed: function() {
                return LE.sessionManager.hasProfilesFeature();
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);
    return ProfilesCollection;
});

